var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMicrosoftTeams = function SvgMicrosoftTeams(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 220 220",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "microsoft-teams-logo@logotyp.us",
    transform: "translate(-170 -90)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 32.086,
    cy: 32.086,
    r: 32.086,
    transform: "translate(254.789 99.164)",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1",
    d: "M284.586 138.125h-29.054l.144.639.014.055.144.592a32.253 32.253 0 0037.909 23.182v-15.3a9.235 9.235 0 00-9.164-9.164h.007z",
    fill: "rgba(0,0,0,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2",
    d: "M277.711 145h-19.828a32.131 32.131 0 0028.992 18.336v-9.165a9.235 9.235 0 00-9.164-9.164z",
    fill: "rgba(0,0,0,0.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2",
    cx: 24.063,
    cy: 24.063,
    r: 24.063,
    transform: "translate(335 117.5)",
    fill: "#5059c9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M379.688 172.5h-54.045a4.414 4.414 0 00-4.393 4.393v55.756a35.309 35.309 0 0027.266 34.96A34.419 34.419 0 00390 233.949v-51.137a10.361 10.361 0 00-10.312-10.312z",
    fill: "#5059c9"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4",
    d: "M341.875 182.813v65.343A54.966 54.966 0 01239.3 275.625a49.447 49.447 0 01-3.438-6.875 57.486 57.486 0 01-2.268-6.875 56.622 56.622 0 01-1.719-13.75V182.8a10.348 10.348 0 0110.3-10.3h89.4a10.348 10.348 0 0110.3 10.3z",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5",
    d: "M277.711 145h-19.828a32.131 32.131 0 0028.992 18.336v-9.165a9.235 9.235 0 00-9.164-9.164z",
    fill: "rgba(0,0,0,0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6",
    d: "M293.75 172.5v87.106a9.1 9.1 0 01-7.15 8.869 6.661 6.661 0 01-1.994.275h-48.744a57.486 57.486 0 01-2.268-6.875 56.622 56.622 0 01-1.719-13.75V182.8a10.348 10.348 0 0110.3-10.3z",
    fill: "rgba(0,0,0,0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7",
    d: "M286.875 172.5v93.981a6.661 6.661 0 01-.275 1.994 9.1 9.1 0 01-8.869 7.15H239.3a49.33 49.33 0 01-3.437-6.875 57.308 57.308 0 01-2.269-6.875 56.622 56.622 0 01-1.719-13.75V182.8a10.348 10.348 0 0110.3-10.3h44.7zm0 0v80.231a9.229 9.229 0 01-9.144 9.144h-44.137a56.622 56.622 0 01-1.719-13.75V182.8a10.348 10.348 0 0110.3-10.3zm-44.688 0h-.013a10.348 10.348 0 00-10.3 10.3v65.326a56.622 56.622 0 001.719 13.75h37.262a9.229 9.229 0 009.145-9.145V172.5z",
    fill: "rgba(0,0,0,0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8",
    d: "M179.164 145h91.665a9.208 9.208 0 019.164 9.164v91.665a9.208 9.208 0 01-9.164 9.164h-91.665a9.208 9.208 0 01-9.164-9.164v-91.665a9.208 9.208 0 019.164-9.164z",
    fill: "#4b53bc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9",
    d: "M252.363 179.2h-20.55v55.138h-13.5V179.2h-20.669v-13.541h54.719z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1",
    fill: "none",
    d: "M170 90h220v220H170z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicrosoftTeams, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/microsoft-teams.0d466548.svg";
export { ForwardRef as ReactComponent };